import { fetchPickableTeamParticipantUsers, fetchTeam, fetchTeamOccupancy } from './effects';
import { setUserOccupancyByTeamParticipantUserIdMap } from './events';
import {
    $team,
    $teamOccupancy,
    $teamPickableParticipantUsers,
    $userOccupancyByTeamParticipantUserIdMap,
} from './states';

import '../pages/TeamTaskFeedback/store/init';

// Team pickable participant user list
$teamPickableParticipantUsers.on(fetchPickableTeamParticipantUsers.doneData, (_, data) => data);

// Team data
$team.on(fetchTeam.doneData, (_, data) => data);

// Team occupancy
$teamOccupancy.on(fetchTeamOccupancy.doneData, (_, data) => data);

// Set user occupancy by team participant user id map
$userOccupancyByTeamParticipantUserIdMap.on(setUserOccupancyByTeamParticipantUserIdMap, (_, data) => data);
